import React from "react";
import { iconProps } from "../../Helper";

const RightScrollIcon = ({className}:iconProps) => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
      className={className}
        d="M0.570312 13.75L5.39731 7L0.570312 0.25H2.40481L7.23181 7L2.40481 13.75H0.570312ZM6.44331 13.75L11.2703 7L6.44331 0.25H8.27806L13.1048 7L8.27806 13.75H6.44331Z"
        fill="white"
      />
    </svg>
  );
};

export default RightScrollIcon;
